import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function BuildingUsersReadOnly({ users, buildingId }) {
  const navigate = useNavigate();

  return (
    <div className="building_users-container">
      <div className="building_users-header-row">
        <h2 className="building_users-title">Usagers du bâtiment</h2>
        {buildingId && (
          <button
            type="button"
            className="small-black-button"
            onClick={() => navigate(`/client/${buildingId}/usages?open=distribution`)}
          >
            Gérer les usagers
          </button>
        )}
      </div>

      {users.length === 0 ? (
        <p className="building_users-empty">
          {buildingId
            ? "Aucun usager défini pour ce bâtiment."
            : "Enregistrez le bâtiment pour pouvoir y ajouter des usagers."}
        </p>
      ) : (
        users.map((user, index) => (
          <div key={user.user_id || index} className="building_users-card building_users-card--readonly">
            <div className="building_users-card-header">
              <strong>{user.name || "Sans nom"}</strong>
            </div>
            <div className="building_users-card-details">
              <p><strong>Nombre :</strong> {user.number}</p>
              <p><strong>Présence :</strong> {user.weekly_usage} j/sem – {user.yearly_usage} sem/an</p>
              <p><strong>Temps sur site :</strong> {user.mean_time_on_site} h</p>
              <p><strong>Part douche :</strong> {user.share_shower} %</p>
            </div>
          </div>
        ))
      )}
    </div>
  );
}
